import { render } from "./prRank.vue?vue&type=template&id=34fab63a&scoped=true"
import script from "./prRank.vue?vue&type=script&lang=js"
export * from "./prRank.vue?vue&type=script&lang=js"

import "./prRank.vue?vue&type=style&index=0&id=34fab63a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fab63a"]])

export default __exports__